import moment from 'moment';
import { TrackableEntities, CHANGE_TYPES } from '../constants';

const availableEntities = [
  {
    value: TrackableEntities.LabSample,
    label: 'enums.entities.LabSample',
  },
  {
    value: TrackableEntities.LabSampleAnalysisOperationValue,
    label: 'enums.entities.LabSampleAnalysisOperationValue',
  },
  {
    value: TrackableEntities.LabSampleAnalysisStatus,
    label: 'enums.entities.LabSampleAnalysisStatus',
  },
  {
    value: TrackableEntities.UserRoles,
    label: 'enums.entities.UserRoles',
  },
  {
    value: TrackableEntities.RoleConfig,
    label: 'enums.entities.RoleConfig',
  },
  {
    value: TrackableEntities.OperationRegistry,
    label: 'enums.entities.OperationRegistry',
  },
  {
    value: TrackableEntities.UserSessionLogin,
    label: 'enums.entities.UserSessionLogin',
  },
  {
    value: TrackableEntities.AnalysisSpecification,
    label: 'enums.entities.AnalysisSpecification',
  },
  {
    value: TrackableEntities.Quarantine,
    label: 'enums.entities.Quarantine',
  },
  {
    value: TrackableEntities.Thermostat,
    label: 'enums.entities.Thermostat',
  },
];

const changeTypeList = [
  {
    value: CHANGE_TYPES.addition,
    label: 'enums.changeTypes.addition',
  },
  {
    value: CHANGE_TYPES.update,
    label: 'enums.changeTypes.update',
  },
  {
    value: CHANGE_TYPES.removal,
    label: 'enums.changeTypes.removal',
  },
];

const changeLogFilters = [
  {
    name: 'userName',
    label: 'userName',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'timestampChange',
    label: 'timestampChange',
    type: 'dateRange',
  },
  {
    name: 'entityName',
    label: 'entityName',
    type: 'select',
    whereOperator: '=',
    options: availableEntities,
  },
  {
    name: 'labSampleCode',
    label: 'sampleId',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'analysisCode',
    label: 'analysisId',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'analysisDescription',
    label: 'analysisDescriptionFull',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'articleDescriptions',
    label: 'articleDescriptions',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'articleCodes',
    label: 'articleCodes',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'lot',
    label: 'lot',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'changeType',
    label: 'changeType',
    type: 'select',
    whereOperator: '=',
    options: changeTypeList,
  },
];

export const advancedFilters = [
  {
    name: 'source',
    label: 'advancedReviewFilter',
    type: 'toggle',
    whereOperator: '=',
    activeValue: 'advancedRevision',
    activeLabel: 'filters.advancedReviewFilter',
    permissions: ['advancedRevisionView'],
  },
];

export const advancedEntities = [
  {
    value: TrackableEntities.ReportSampleInfo,
    label: 'enums.entities.ReportSampleInfo',
  },
  {
    value: TrackableEntities.ReportTemperatureLog,
    label: 'enums.entities.ReportTemperatureLog',
  },
  {
    value: TrackableEntities.SampleReportRevision,
    label: 'enums.entities.SampleReportRevision',
  },
];

export const DEFAULT_RANGE_DAYS = 30;

export const DEFAULT_CHANGE_LOG_SORTING = {
  prop: 'timestampChange',
  order: 'descending',
};

export const defaultChangeLogFilterData = (now = moment()) => {
  const range = [
    now.clone().subtract(DEFAULT_RANGE_DAYS, 'days').format('YYYY-MM-DD'),
    now.format('YYYY-MM-DD'),
  ];
  return { timestampChange: [{ key: range, label: `${range}` }] };
};

export default changeLogFilters;
